import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";


function useCandidateIntro(props) {
  const [userData, setUserData] = useState({});
  const [loading, setloading] = useState(false);
  const [educationData, setEducationData] = useState([]);
  const [professionData, setProfessionData] = useState([]);


  //get data from redux
  const { userProfileData } = useSelector(
    (state) => state.get_candidate_profile_data_reducer
  );

  //get data from redux
  const { userEducationalData } = useSelector(
    (state) => state.get_candidate_all_educational_data_reducer
  );

  //get data from redux
  const { userProfessionalData } = useSelector(
    (state) => state.get_candidate_all_professional_data_reducer
  );

  useEffect(() => {
    if (userProfileData?.data !== undefined) {
      setUserData(userProfileData?.data);
    }
  }, [userProfileData]);

  useEffect(() => {
    if(userEducationalData?.data !== undefined)
    setEducationData(userEducationalData?.data);
  }, [userEducationalData]);

  useEffect(() => {
    if(userProfessionalData?.data !== undefined)
    setProfessionData(userProfessionalData?.data);
  }, [userProfessionalData]);

  return {
    loading,
    userData,
    educationData,
    professionData,
  };
}
export default useCandidateIntro;
